/**
 * Plantillas de primer contacto con administraciones de edificios (canal B2B).
 * A diferencia de la venta a edificios directos, acá NO competimos: trabajamos
 * junto a la administración sacándole la trastienda (facturas, cierres, atención
 * a residentes) con los 3 planes por unidad. El mensaje acompaña el material de
 * los planes. Placeholders: {administracion} y {agente}.
 */

const rellenar = (t, { administracion, agente }) =>
  t.replaceAll("{administracion}", administracion || "el equipo")
   .replaceAll("{agente}", agente || "el equipo de Habitia");

const WHATSAPP = `Hola! Mi nombre es {agente}, soy agente comercial de Habitia.
Les escribo porque trabajamos junto a administraciones de edificios: les sacamos la parte más pesada de la trastienda —carga de facturas, cierres y atención de consultas de los residentes— con una plataforma propia con IA, para que puedan sumar edificios sin sumar la misma carga de trabajo.
Les comparto el material de nuestros planes (por unidad y por mes, para elegir cuánto delegar) y, si les interesa, coordinamos una llamada corta para verlo con uno de sus edificios y números reales.`;

const MAIL_ASUNTO = `Habitia · el back office de {administracion}, resuelto con IA`;

const MAIL_CUERPO = `Hola, equipo de {administracion},
Mi nombre es {agente} y soy agente comercial de Habitia: la plataforma con inteligencia artificial para administrar edificios.
Les escribo porque con las administraciones no competimos, trabajamos juntos: Habitia les resuelve la parte más pesada de atrás —la carga de facturas, los cierres y la atención de consultas de los residentes— para que se dediquen a lo suyo (la comisión, el edificio, la asamblea) y puedan crecer sin sumar back office en la misma proporción.
Son tres niveles, por unidad y por mes, para elegir cuánto delegar: desde la plataforma con IA para trabajar ustedes, hasta el back office completo. Les adjunto el material con el detalle de los planes.
Si les interesa, me encantaría coordinar una reunión corta para verlo con uno de sus edificios y evaluar cuántas horas de trabajo les ahorra.
Saludos,
{agente} · Habitia`;

/** Mensaje de WhatsApp listo (texto plano). */
export function plantillaWhatsappAdmin(vars) {
  return rellenar(WHATSAPP, vars);
}

/** Mail listo: { asunto, cuerpo }. */
export function plantillaMailAdmin(vars) {
  return { asunto: rellenar(MAIL_ASUNTO, vars), cuerpo: rellenar(MAIL_CUERPO, vars) };
}
